import { get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'
import { enrichComment, enrichProcessInstance } from './enrich-process-instance'

import { findSalesOrderSuccess } from '../../../sales-order/state/detail/action'
import { getUIDefinitionByStateName } from '../../ui-definition/ui-definition'
import * as processAction from '../../ui-definition/process-action'
import { findCustomerSuccess } from '../../../customer/state/detail/action'
import { treatmentPlanLoaded } from '../../../treatment/state/plan/action'
import { processTaskLoaded } from '../../../treatment/state/quotation/action'
import { findProspectSuccess } from '../../../prospect/state/detail/action'

const ACTION_MAPPING = {
    [processAction.CUSTOMER]: findCustomerSuccess,
    [processAction.TREATMENT_PLAN]: treatmentPlanLoaded,
    [processAction.TREATMENT_QUOTATION]: processTaskLoaded,
}

export const processInstanceLoaded = (processInstance) => (dispatch, getState) => {
    enrichProcessInstance(getState(), processInstance)
    dispatch({
        type: type.PROCESS_INSTANCE_LOADED,
        payload:
            {
                processInstance,
            },
    })
}


export const findProcessInstanceRequest = () => ({
    type: type.FIND_PROCESS_INSTANCE_REQUEST,
})

export const dispatchActionList = (processInstance, dispatch) => {
    const definition = getUIDefinitionByStateName(processInstance.currentStateName)
    if (!definition || !definition.actionList) {
        return
    }

    definition.actionList.map(({ action, taskPath }) => {
        action = ACTION_MAPPING[action]

        if (!action) {
            return null
        }

        let actionData = processInstance

        for (let index = 0; index < taskPath.length; index++) {
            const key = taskPath[index]
            actionData = actionData ? actionData[key] : null
        }
        return dispatch(action(actionData))
    })
}


export const findProcessInstanceSuccess = (processInstance) => (dispatch, getState) => {
    enrichProcessInstance(getState(), processInstance)
    dispatchActionList(processInstance, dispatch)

    if (processInstance.masterObject === 'salesorder_salesorder') {
        dispatch(findSalesOrderSuccess(processInstance.objectDetail))
    }
    if (processInstance.masterObject === 'prospect_prospect') {
        dispatch(findProspectSuccess(processInstance.objectDetail))
    }

    dispatch({
        type: type.FIND_PROCESS_INSTANCE_SUCCESS,
        payload:
            {
                processInstance,
            },
    })
}

export const findProcessInstanceError = (error) => ({
    type: type.FIND_PROCESS_INSTANCE_ERROR,
    payload: {
        error,
    },
})


export const findProcessInstance = (processInstanceId) => (dispatch, getState) => {
    dispatch(findProcessInstanceRequest())

    get('/api/process/instance/find-full?processInstanceId=' + processInstanceId)
        .then(processInstance => {
            dispatch(findProcessInstanceSuccess(processInstance))
        })
        .catch(error => {
            dispatch(findProcessInstanceError(error))
        })
}


export const findProcessInstanceByMasterId = (masterObject, masterId) => (dispatch, getState) => {
    dispatch(findProcessInstanceRequest())

    get('/api/process/instance/find-full-by-master-id?masterObject=' + masterObject + '&masterId=' + masterId)
        .then(processInstance => {
            dispatch(findProcessInstanceSuccess(processInstance))
        })
        .catch(error => {
            console.dir(error)
            dispatch(findProcessInstanceError(error))
        })
}

export const toggleProcessFlowVisibility = () => ({
    type: type.TOGGLE_PROCESS_FLOW_VISIBILITY,
})


export const toggleVIPStatusRequest = () => ({
    type: type.TOGGLE_VIP_STATUS_REQUEST,
})

export const toggleVIPStatusSuccess = () => ({
    type: type.TOGGLE_VIP_STATUS_SUCCESS,
})

export const toggleVIPStatusError = (error) => ({
    type: type.TOGGLE_VIP_STATUS_ERROR,
    payload: {
        error,
    },
})

export const toggleVIPStatus = () => (dispatch, getState) => {
    dispatch(toggleVIPStatusRequest())

    const state = getState()
    const processInstanceId = selector.selectProcessInstance(state).id
    const vipStatus = !selector.selectVIPStatus(state)

    get('/api/process/instance/set-vip-status?processInstanceId=' + processInstanceId + '&vip=' + vipStatus)
        .then(() => {
            dispatch(toggleVIPStatusSuccess())
        })
        .catch(error => {
            dispatch(toggleVIPStatusError(error))
        })
}

export const toggleRushStatusRequest = () => ({
    type: type.TOGGLE_RUSH_STATUS_REQUEST,
})

export const toggleRushStatusSuccess = () => ({
    type: type.TOGGLE_RUSH_STATUS_SUCCESS,
})

export const toggleRushStatusError = (error) => ({
    type: type.TOGGLE_RUSH_STATUS_ERROR,
    payload: {
        error,
    },
})

export const toggleRushStatus = () => (dispatch, getState) => {
    dispatch(toggleRushStatusRequest())

    const state = getState()
    const processInstanceId = selector.selectProcessInstance(state).id
    const rushStatus = !selector.selectRushStatus(state)

    get('/api/process/instance/set-rush-status?processInstanceId=' + processInstanceId + '&rush=' + rushStatus)
        .then(() => {
            dispatch(toggleRushStatusSuccess())
        })
        .catch(error => {
            dispatch(toggleRushStatusError(error))
        })
}

export const changeProcessComment = (name, value) => ({
    type: type.CHANGE_PROCESS_COMMENT,
    payload: {
        name,
        value,
    },
})

export const commentProcessInstanceRequest = () => ({
    type: type.COMMENT_PROCESS_INSTANCE_REQUEST,
    payload: {},
})

export const commentProcessInstanceSuccess = (comment) => ({
    type: type.COMMENT_PROCESS_INSTANCE_SUCCESS,
    payload: {
        comment,
    },
})

export const commentProcessInstanceError = (error) => ({
    type: type.COMMENT_PROCESS_INSTANCE_ERROR,
    payload: {
        error,
    },
})

export const commentProcessInstance = () => (dispatch, getState) => {
    dispatch(commentProcessInstanceRequest())

    const state = getState()
    const processInstanceId = selector.selectProcessInstanceId(state)
    const commentText = selector.selectCommentText(state)

    post('/api/process/instance/comment', {
        processInstanceId,
        commentText,
    })
        .then((comment) => {
            enrichComment(state, comment)
            dispatch(commentProcessInstanceSuccess(comment))
        })
        .catch(error => {
            dispatch(commentProcessInstanceError(error))
        })
}


export const changeProcessContext = (name, value) => ({
    type: type.CHANGE_PROCESS_CONTEXT,
    payload: {
        name,
        value,
    },
})

export const saveProcessContextRequest = () => ({
    type: type.SAVE_PROCESS_CONTEXT_REQUEST,
})

export const saveProcessContextSuccess = (context) => ({
    type: type.SAVE_PROCESS_CONTEXT_SUCCESS,
    payload: {
        context
    }
})

export const saveProcessContextError = (error) => ({
    type: type.SAVE_PROCESS_CONTEXT_ERROR,
    payload: {
        error,
    },
})

export const saveProcessContext = () => (dispatch, getState) => {
    dispatch(saveProcessContextRequest())

    const state = getState()
    const processInstanceId = selector.selectProcessInstanceId(state)
    const context = selector.selectProcessContext(state)

    post('/api/process/instance/save-context', {
        processInstanceId,
        context,
    })
        .then(processInstance => {
            dispatch(saveProcessContextSuccess())
        })
        .catch(error => {
            dispatch(saveProcessContextError(error))
        })
}



export const updateContext = (contextDiff) => (dispatch, getState) => {
    dispatch(saveProcessContextRequest())

    const state = getState()
    const processInstanceId = selector.selectProcessInstanceId(state)
    const context = {
        ...selector.selectProcessContext(state),
        ...contextDiff,
    };

    post('/api/process/instance/save-context', {
        processInstanceId,
        context,
    })
        .then(processInstance => {
            dispatch(saveProcessContextSuccess(processInstance.context))
        })
        .catch(error => {
            dispatch(saveProcessContextError(error))
        })
}



export const setValidationMessageList = (validationMessageList) => ({
    type: type.SET_VALIDATION_MESSAGE_LIST,
    payload: {
        validationMessageList,
    },
})


export const fireEventRequest = () => ({
    type: type.FIRE_EVENT_REQUEST,
    payload: {},
})

export const fireEventSuccess = (processInstance) => ({
    type: type.FIRE_EVENT_SUCCESS,
    payload: {
        processInstance,
    },
})

export const fireEventError = (error) => ({
    type: type.FIRE_EVENT_ERROR,
    payload: {
        error,
    },
})


const validateEvent = (state, stateName, eventName) => {
    const uiDefinition = getUIDefinitionByStateName(stateName)

    const { taskValidatorSelector = [], taskValidator } = uiDefinition
    if (!taskValidator) {
        return null
    }

    const processInstance = selector.selectProcessInstance(state)

    const validatorParameter = []
    for (let index = 0; index < taskValidatorSelector.length; index++) {
        const validatorParameterSelector = taskValidatorSelector[index]
        validatorParameter.push(validatorParameterSelector(state))
    }

    return taskValidator(processInstance, eventName, ...validatorParameter)
}

export const validateAndTriggerEvent = (processInstanceId, stateName, eventName) => (dispatch, getState) => {
    const state = getState()
    const validationMessageList = validateEvent(state, stateName, eventName)
    if (validationMessageList && validationMessageList.length !== 0) {
        dispatch(setValidationMessageList(validationMessageList))
        return
    }

    dispatch(fireEventRequest())

    get('/api/process/instance/fire-event?processInstanceId=' + processInstanceId + '&eventName=' + eventName)
        .then(processInstance => {
            enrichProcessInstance(getState(), processInstance)
            dispatch(findProcessInstanceSuccess(processInstance))
        })
        .catch(error => {
            dispatch(fireEventError(error))
        })
}


export const changeTimeRequest = () => ({
    type: type.CHANGE_TIME_REQUEST,
})

export const changeTimeSuccess = (name, value) => ({
    type: type.CHANGE_TIME_SUCCESS,
    payload: {
        name,
        value,
    },
})

export const changeTimeError = (error) => ({
    type: type.CHANGE_TIME_ERROR,
    payload: {
        error,
    },
})


export const changeTime = (name, newTime) => (dispatch, getState) => {
    const state = getState()
    const processInstanceId = selector.selectProcessInstanceId(state)
    if (!processInstanceId) {
        return
    }

    dispatch(changeTimeRequest())


    post('/api/process/instance/change-wakeup-time', {
        processInstanceId,
        name,
        newTime,
    })
        .then(reponse => {
            dispatch(changeTimeSuccess(name, newTime))
        })
        .catch(error => {
            dispatch(changeTimeError(error))
        })
}


export const changeBeamProcessState = (name, beamProcessState) => ({
    type: type.CHANGE_BEAM_PROCESS_STATE,
    payload: {
        name,
        beamProcessState,
    },
})


export const beamProcessInstanceRequest = () => ({
    type: type.BEAM_PROCESS_INSTANCE_REQUEST,
})

export const beamProcessInstanceSuccess = (processInstance) => ({
    type: type.BEAM_PROCESS_INSTANCE_SUCCESS,
    payload: {
        processInstance,
    },
})

export const beamProcessInstanceError = (error) => ({
    type: type.BEAM_PROCESS_INSTANCE_ERROR,
    payload: {
        error,
    },
})

export const beamProcessInstance = () => (dispatch, getState) => {
    const state = getState()
    const { beamProcessState } = selector.selectBeamProcessState(state)
    const processInstanceId = selector.selectProcessInstanceId(state)


    dispatch(beamProcessInstanceRequest())

    get('/api/process/instance/beam-to-state?processInstanceId=' + processInstanceId + '&stateId=' + beamProcessState)
        .then(processInstance => {
            dispatch(findProcessInstanceSuccess(processInstance))
        })
        .catch(error => {
            dispatch(beamProcessInstanceError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/process/state/instance-detail/action.js